export class LiteModeEntry {
    liteMode: boolean;
    lastUpdated: number;
    doNotPrompt = false;
    doNotUpdate = false;

    constructor(liteMode = false) {
        this.liteMode = liteMode;
    }

    isExpired(maxAge: number): boolean {
        return this.lastUpdated + maxAge < Date.now();
    }
}
